import { render, staticRenderFns } from "./ListInformation.vue?vue&type=template&id=8857a6b8&"
import script from "./ListInformation.vue?vue&type=script&lang=js&"
export * from "./ListInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports